
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aajtak-livetv",
      function () {
        return require("private-next-pages/aajtak-livetv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aajtak-livetv"])
      });
    }
  